/**
* =========================================================================================
* HRMS
* =========================================================================================
*/

import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';
import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'emoji-mart/css/emoji-mart.css';
import 'ubs-framework/v2/plugin/UTaskOfTheDayWidget/index.scss'

import App from './App';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Provider} from 'react-redux';
import storeMaster from './store';
import {PersistGate} from 'redux-persist/integration/react'
import Logout from "./app-hrms/Logout";
import {UAlertProvider} from 'ubs-framework';
import * as serviceWorker from './serviceWorker';

document.addEventListener('keypress', logKey);

const {store, persistor} = storeMaster();

let logger = function () {
    /* +-------------------------------------------------------------------+
     desc: Enable or disable logger and disable warn function.
     +-------------------------------------------------------------------+ */
    let oldConsoleLog = null;
    let pub = {};

    pub.enableLogger = function enableLogger() {
        if (oldConsoleLog == null) return;
        window['console']['log'] = oldConsoleLog;
        console.log('=== LOG ENABLED ===');
    };
    pub.disableLogger = function disableLogger() {
        oldConsoleLog = console.log;
        window['console']['log'] = () => {
        };
    };
    pub.disableWarn = function disableWarn() {
        window['console']['warn'] = () => {
        };
    };
    return pub;
}();

function logKey(e) {
    /* +-------------------------------------------------------------------+
     desc: define log enable disable key.
     +-------------------------------------------------------------------+ */
    if (e.ctrlKey && e.shiftKey) {
        switch (e.code) {
            case 'KeyE':
                logger.disableLogger();
                break;
            case 'KeyS':
                logger.enableLogger();
                break;
            default:
                break;
        }
    }
}

if (window.location.hostname === 'hrms.superworks.com') {
    logger.disableLogger();
    logger.disableWarn();
} else {
    logger.disableWarn();
}
ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <UAlertProvider>
                    <Router>
                        <Switch>
                            <Route exact path="/logout" component={Logout}/>
                        </Switch>
                        <App/>
                    </Router>
                </UAlertProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`);
